export default __webpack_public_path__ + "static/media/lyte-chocolate-bar@2x.3a52628b.png";